import * as PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import { EyeOutlined } from '@ant-design/icons';

const DetailButton = ({ url }) => (
    <Button
        icon={<EyeOutlined />}
        onClick={() => {
            window.open(url, '_blank');
        }}
    />
);

DetailButton.propTypes = {
    url: PropTypes.string.isRequired,
};

export default DetailButton;
